import { ElMessage } from "element-plus";
import { defineStore } from "pinia";
import { 
    getRoleTableData, editRoleData, deleteRoleData, getRoleOptions, getRoleDataById,
    getUserTableData, editUserData, addUserData, deleteUserData, getAuthCodeByPhone,
    getPermissionsList, 
    getEnterpriseTableData, auditEnterprise,
    getPilotTableData, auditPilot
} from "@/services";

const useUserManagementStore = defineStore("userManagement", {
    state: () => ({
        pageTitle: '',
        tableAllData: {},
        selectedTerminal: {
            startingTerminal: [],
            endTerminal: [],
            dockingTerminal: []
        },
        roleOptions: [],
        permissionList: null
    }),
    actions: {
        async getAuthCodeByPhone(params) {
            await getAuthCodeByPhone(params);
        },
        async getPermissionsList(params) {
            let result = await getPermissionsList(params);
            this.permissionList = result?.data?.['飞行汽车管理权限']
        },
        async getRoleDataById(params) {
            let result = await getRoleDataById(params);
            return result.data
        },
        
        async getTableAllData(type, params) {
            let result = {}
            switch(type) {
                case 'role': result = await getRoleTableData(params);break;
                case 'systemUser': result = await getUserTableData(params);break;
                case 'enterpriseCertification': result = await getEnterpriseTableData(params);break;
                case 'pilotCertification': result = await getPilotTableData(params);break;
            }
            this.tableAllData = result.data
        },

        async editTableData(type, params) {
            let result = {}
            switch(type) {
                case 'role': result = await editRoleData(params);this.getRoleOptions();break;
                case 'systemUser': 
                if(params?.id) {
                    result = await editUserData(params);break;
                } else {
                    result = this.addUserData(params);
                }
                break;
                
            }
            return result
        },
        async addUserData(params) {
            let  result = await addUserData(params)
            return result
        },
        
        async deleteTableData(type, params) {
            let result = {}
            switch(type) {
                case 'role': result = await deleteRoleData(params);this.getRoleOptions();break;
                case 'systemUser': result = await deleteUserData(params);break;
            }
            return result
        },
        async auditData(type, params) {
            let result = {}
            switch(type) {
                case 'enterpriseCertification': result = await auditEnterprise(params);break;
                case 'pilotCertification': result = await auditPilot(params);break;
            }
            return result
        },
        async getRoleOptions() {
            let result = await getRoleOptions();
            let options = []
            this.roleOptions = []
            if (result.code === 200) {
                for(let item of result.data) {
                    let option = { 
                        label: item, 
                        value: item 
                    }
                    options.push(option)
                }
                this.roleOptions = options
            } else {
                ElMessage({
                    type: 'error',
                    message: result.message
                })
            }
        },
    },
});

export default useUserManagementStore;
